import { IconLoader } from '@ui/src';
import { ChangeDocumentStatusButtonTypes } from '../types';

import cn from '../styles.module.css';

const ChangeStatusButton = ({
  statusChangeInProgress,
  setSelectedStatus,
  statusForChange,
  allowedCategories,
  documentsByCategoryId,
  allDocuments,
  changeCustomerDocumentsStatusAction,
  selectedStatus,
  buttonText,
  icon,
}: ChangeDocumentStatusButtonTypes) => (
  <button
    type="button"
    className={cn.otherActionMenuButton}
    disabled={statusChangeInProgress}
    onClick={() => {
      setSelectedStatus(statusForChange);

      const selectedDocuments: string[] = [];

      if (allowedCategories && documentsByCategoryId) {
        allowedCategories?.forEach((item) => {
          if (documentsByCategoryId[item.id]) {
            documentsByCategoryId[item.id].forEach((category) => {
              category.documents?.forEach((document) => {
                if (document.isSelected) {
                  selectedDocuments.push(document.id);
                }
              });
            });
          }
        });
      }

      if (allDocuments) {
        allDocuments.all.forEach((item) => {
          item.documents?.forEach((document) => {
            if (
              document.isSelected &&
              !selectedDocuments.find((id) => document.id === id)
            ) {
              selectedDocuments.push(document.id);
            }
          });
        });
      }

      changeCustomerDocumentsStatusAction(statusForChange, selectedDocuments);
    }}
  >
    {statusChangeInProgress && selectedStatus === statusForChange ? (
      <IconLoader
        className={`${cn.selectedDocumentsButtonIcon} ${cn.selectedDocumentsButtonIconMargin}`}
        width={15}
        height={15}
      />
    ) : (
      icon
    )}
    {statusChangeInProgress && selectedStatus === statusForChange
      ? 'Loading...'
      : buttonText}
  </button>
);

export default ChangeStatusButton;
